module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/candidate/candidate.component.scss
// module id = ./src/app/candidate/candidate.component.scss
// module chunks = main